export default {
  title: "Messaggio Chats",
  form: {
    email: {
      label: "Email",
      placeholder: "Enter your email",
    },
    password: {
      label: "Password",
      placeholder: "Enter your password",
    },
    confirmation: {
      label: 'Google Auth code',
      placeholder: 'Google Auth code',
    },
    button: {
      text: "Sign In",
      text_mode_otp: "Sign In",
    },
    forgotlink: "Forgot your password?"
  },
  signuptext: "Don't have an account ?",
  signuplink: "Signup now",
  oauth_loading: 'OAuth loading ...',

  errors: {
    max_rate_limiting_reached: {
      title: 'Max rate limiting reached, please try after some time',
    },
    error403: {
      title: 'Authorization error',
      description: 'Login or password is incorrect. Please, check it and try again.',
    },
  },
}
